const newArea = {
  snackbar: "Ihr Update ist fertig",
  name: "Bereichsname",
  save: "speichern",
  cancel: "Stornieren",
  area: "Bereich",
  formTitle: "Neues Gebiet",
  confirm: "Möchten Sie diesen Artikel wirklich löschen?",
  close: "Schließen",
  delete: "Löschen"
};
export default newArea;
